module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_01_1280_1280_en-22c7c02846ba1ede8b3586eac2ea12cf.jpg";